import { GeneratorParams, NUMBER_COLUMN_ID } from ".";
import { Item } from "../../types";

export default function generate(
    { names, creationTimes, random }: GeneratorParams,
    lastStatusPerItem: { [item: string]: number }
): Item[] {
    const items: Item[] = names.map((name, i) => {
        return {
            id: `${i}`,
            name: name,
            state: "active",
            created_at: creationTimes[i % creationTimes.length].utc().format("YYYY-MM-DD HH:mm:ss UTC"),
            column_values: [
                {
                    id: "status",
                    type: "status",
                    text: null,
                    valueJson: { index: lastStatusPerItem[i] },
                    label: "status label",
                    label_style: {
                        color: "#000000",
                        border: "#000000"
                    }
                },
                {
                    id: NUMBER_COLUMN_ID,
                    type: "numbers",
                    text: null,
                    valueJson: `${random() * 100}`,
                }
            ]
        };
    });

    return items;
}
